import Axios from 'axios';
import header from './auth/header';

const API_URL = process.env.API_URL + '/api/v1/';
const API_URL_V3 = process.env.API_URL + '/api/v3';

class Pengajuan {
  index() {
    return Axios.get(API_URL + 'pengajuan-list', { headers: header() });
  }

  show(pengajuan) {
    return Axios.get(API_URL + `pengajuan/${pengajuan}`, { headers: header() });
  }

  showPengajuanMitraPendukungCorporate(pengajuan) {
    return Axios.get(API_URL_V3 + `/pengajuan/mitra-pendukung/${pengajuan}?with=product.category,product.subCategory,mitra.mitra_profile`, { headers: header() });
  }

  showV3(pengajuan) {
    return Axios.get(API_URL_V3 + `/pengajuan-lending/funder/${pengajuan}`, { headers: header() });
  }

  store(data) {
    return Axios.post(API_URL_V3 + '/pengajuan/funder', data, { headers: header() });
  }

  update(data) {
    return Axios.put(API_URL + 'update-pengajuan', data, { headers: header() });
  }

  destroy(data) {
    return Axios.delete(API_URL + 'delete-pengajuan', data, { headers: header() });
  }

  pengajuanFilter(filter, id) {
    return Axios.get(API_URL + `pengajuan-list/filter/${filter}/${id}`);
  }

  pengajuanMitra() {
    return Axios.get(API_URL + `pengajuan-mitra-list`, { headers: header() });
  }

  pengajuanLendingMitra() {
    return Axios.get(API_URL_V3 + `/pengajuan-lending/mitra-utama`, { headers: header() });
  }

  totalPengajuanMitra() {
    return Axios.get(API_URL + `total-pengajuan-mitra-list`, { headers: header() });
  }

  totalPengajuanMitraHariIni() {
    return Axios.get(API_URL + `total-pengajuan-mitra-day`, { headers: header() });
  }

  totalPengajuanMitraProses() {
    return Axios.get(API_URL + `total-pengajuan-mitra-proses`, { headers: header() });
  }

  totalNasabahMitra() {
    return Axios.get(API_URL + `total-nasabah-mitra-list`, { headers: header() });
  }

  produkPopuler() {
    return Axios.get(API_URL + `produk-populer-mitra-list`, { headers: header() });
  }

  nasabahPopuler() {
    return Axios.get(API_URL + `nasabah-populer-mitra-list`, { headers: header() });
  }

  pengajuanMasukMitra() {
    return Axios.get(API_URL + `pengajuan-masuk-mitra-list`, { headers: header() });
  }

  pengajuanLendingMasukMitra() {
    return Axios.get(API_URL_V3 + `/pengajuan-lending/mitra-pendukung`, { headers: header() });
  }

  pengajuanFunder(params = {}) {
    return Axios.get(API_URL + `pengajuan-funder-list`, {headers: header(), params});
  }

  pengajuanFunderSuccess() {
    return Axios.get(API_URL + `pengajuan-funder-success`, { headers: header() });
  }

  changeStatus(data) {
    return Axios.patch(API_URL + 'pengajuan/change-status', data, { headers: header() })
  }

  approvePengajuanByMitraPendukung(data) {
    return Axios.post(API_URL_V3 + `/pengajuan-lending/mitra-pendukung/process/${data}?action=approve`, data, { headers: header() })
  }

  approvePengajuanByMitraUtama(data) {
    return Axios.post(API_URL_V3 + `/pengajuan-lending/mitra-utama/process/${data}?action=approve`, data, { headers: header() })
  }

  changeReject(data) {
    return Axios.patch(API_URL + 'pengajuan/pengajuan-cancel', data, { headers: header() })
  }

  listNasabah() {
    return Axios.get(API_URL + `funder-on-mitra`, { headers: header() });
  }
  listNasabahCorporate() {
    return Axios.get(API_URL_V3 + `/users/mitra?role_id=4&with=userCorporateDetail.legalEntityType`, { headers: header() });
  }

  getIsFillFunderData() {
    return Axios.get(API_URL + `getIsFillFunderData`, { headers: header() });
  }

  isFunderCompleteProfile() {
    return Axios.get(API_URL_V3 + `/auth/check/profile-completion`, { headers: header() });
  }

  rejectStatus(pengajuan_id) {
    return Axios.patch(API_URL + `mitra/reject-user/${pengajuan_id}`, null, { headers: header() });
  }

  utamaRejectStatus(pengajuan_id) {
    return Axios.patch(API_URL + `mitra-utama/reject-user/${pengajuan_id}`, null, { headers: header() });
  }

  uploadPaymentProofV3(data) {
    return Axios.post(API_URL_V3 + '/pengajuan/payment-confirmation/', data, { headers: header() });
  }

  uploadPaymentProof(data) {
    return Axios.post(API_URL + 'payment-confirmation', data, { headers: header() });
  }

  uploadDocumentPengajuan(data) {
    return Axios.post(API_URL + 'pengajuan-document', data, { headers: header() });
  }

  funderReceiveDocument(data) {
    return Axios.post(API_URL + 'funder-receive-document', data, { headers: header() });
  }

  pengajuanPaymentMitra() {
    return Axios.get(API_URL + `pengajuan-payment-mitra-list`, { headers: header() });
  }

  changePaymentStatus(data) {
    return Axios.patch(API_URL + 'pengajuan/change-payment-status', data, { headers: header() })
  }

  toggleARO(data) {
    return Axios.patch(API_URL + `aro/${data}`, data, { headers: header() })
  }

  downloadPengajuanMasukMitra() {
    return Axios.get(API_URL_V3 + '/download/pengajuan-masuk-mitra', {
      headers: header(),
      responseType: 'blob'
    });
  }

  downloadPengajuanMitra() {
    return Axios.get(API_URL_V3 + '/download/pengajuan-mitra', {
      headers: header()
    });
  }

  downloadPengajuan(id) {
    return Axios.get(API_URL_V3 + `/pengajuan/download/${id}/detail-pengajuan`, {
      headers: header(),
      responseType: 'blob'
    });
  }

  downloadDataFunderManajemenPengajuan(roleId) {
    return Axios.get(API_URL_V3 + `/pengajuan/download/mitra/${roleId}/utama`, {
      headers: header()
    });
  }
  
  downloadDataFunderPengajuanMasuk(roleId) {
    return Axios.get(API_URL_V3 + `/pengajuan/download/mitra/${roleId}/utama`, {
      headers: header()
    });
  }

  uploadReturnTracking(data) {
    return Axios.post(API_URL + 'upload-return-tracking', data, { headers: header() });
  }

  pengajuanPengembalianMitra() {
    return Axios.get(API_URL + `pengajuan-pengembalian-mitra-list`, { headers: header() });
  }

  changePengajuanStatus(data) {
    return Axios.patch(API_URL + 'pengajuan/change-pengembalian-status', data, { headers: header() })
  }

  changeStatusToLunas(data) {
    return Axios.patch(API_URL + 'pengajuan/change-pengajuan-to-lunas', data, { headers: header() })
  }

  getDocumentUrl(data) {
    return Axios.post(API_URL_V3 + '/pengajuan/sign/funder/document-url', data, { headers: header() });
  }

  getMitraDocumentUrl(encrypted_key, data) {
    return Axios.post(API_URL_V3 + `/pengajuan/sign/mitra/${encrypted_key}/document-url`, data);
  }

  getUrlWebviewAuthSign(data) {
    return Axios.post(API_URL_V3 + '/pengajuan/sign/funder/webview-auth-sign', data, { headers: header() });
  }

  getUrlMitraAuthSign(data) {
    return Axios.post(API_URL_V3 + `/pengajuan/sign/mitra/setup-auth-url`, data, { headers: header() });
  }

  sendEmailToSigner(data) {
    return Axios.post(API_URL_V3 + '/pengajuan/sign/mitra/resend-auth-url', data, { headers: header() });
  }

  getUrlWebviewMitraAuthSign(encrypted_key, data) {
    return Axios.post(API_URL_V3 + `/pengajuan/sign/mitra/${encrypted_key}/webview-auth-sign`, data);
  }

  redirectAuthSign(encrypted_key, data) {
    return Axios.post(API_URL_V3 + `/pengajuan/sign/${encrypted_key}/redirect-auth-sign`, data);
  }

  previewTilakaDocument(data) {
    return Axios.post(API_URL + 'preview-pdf-tilaka', data, { headers: header() });
  }

  downloadTilakaDocument(data) {
    return Axios.post(API_URL + 'download-pdf-tilaka', data, { headers: header() });
  }

  pengajuanListMitraV3() {
    return Axios.get(API_URL_V3 + '/pengajuan/mitra-utama?with=product,funder.userCorporateDetail,funder.role,funder.userCorporateDetail.legalEntityType,statusChangeBy,statusUtamaChangeBy,pengajuanSign', { headers: header() });
  }
  pengajuanListMitraPendukungV3() {
    return Axios.get(API_URL_V3 + '/pengajuan/mitra-pendukung?with=product,funder.userCorporateDetail,funder.role,funder.userCorporateDetail.legalEntityType,document,statusChangeBy,statusUtamaChangeBy', { headers: header() });
  }

  checkRejection() {
    return Axios.get(API_URL_V3 + '/pengajuan/funder/check-rejection', { headers: header() });
  }
}

export default new Pengajuan();


// WEBPACK FOOTER //
// ./src/api/pengajuan.js